export const foodDatabase = [
  // Proteins
  {
    id: 1,
    name: "Chicken Breast (Cooked)",
    category: "Protein",
    calories: 164,
    protein: 30.76,
    carbs: 0,
    fat: 3.54,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "piece"]
  },
  {
    id: 2,
    name: "Salmon (Atlantic)",
    category: "Protein",
    calories: 208,
    protein: 25.4,
    carbs: 0,
    fat: 12.4,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "fillet"]
  },
  {
    id: 3,
    name: "Ground Turkey (93% lean)",
    category: "Protein",
    calories: 176,
    protein: 24.9,
    carbs: 0,
    fat: 8.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "patty"]
  },
  {
    id: 4,
    name: "Eggs (Large)",
    category: "Protein",
    calories: 155,
    protein: 13,
    carbs: 1.1,
    fat: 11,
    servingSize: 1,
    servingUnit: "egg",
    servingOptions: ["egg", "g"]
  },
  {
    id: 5,
    name: "Chobani Greek Yogurt",
    category: "Protein",
    calories: 26,
    protein: 4.71,
    carbs: 1.76,
    fat: 0,
    servingSize: 50,
    servingUnit: "g",
    servingOptions: ["g", "cup", "container"]
  },
  {
    id: 6,
    name: "Cottage Cheese (Low-fat)",
    category: "Protein",
    calories: 72,
    protein: 12.4,
    carbs: 4.3,
    fat: 1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 7,
    name: "Tofu (Firm)",
    category: "Protein",
    calories: 144,
    protein: 17.3,
    carbs: 2.8,
    fat: 8.7,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "block"]
  },
  {
    id: 8,
    name: "Beef Angus Stake (Cooked)",
    category: "Protein",
    calories: 250,
    protein: 31,
    carbs: 0,
    fat: 14,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "steak"]
  },
  {
    id: 9,
    name: "Tuna (Canned in Water)",
    category: "Protein",
    calories: 116,
    protein: 25.5,
    carbs: 0,
    fat: 0.8,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "can", "oz"]
  },
  {
    id: 10,
    name: "Whey Protein Powder",
    category: "Protein",
    calories: 103,
    protein: 20,
    carbs: 2,
    fat: 1.5,
    servingSize: 1,
    servingUnit: "scoop",
    servingOptions: ["scoop", "g"]
  },
  {
    id: 11,
    name: "Chicken Thigh (Skinless)",
    category: "Protein",
    calories: 209,
    protein: 26,
    carbs: 0,
    fat: 10.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "thigh"]
  },
  {
    id: 12,
    name: "Shrimp (Cooked)",
    category: "Protein",
    calories: 117,
    protein: 24.73,
    carbs: 0,
    fat: 1.73,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "piece"]
  },
  // Carbohydrates
  {
    id: 13,
    name: "Brown Rice (Cooked)",
    category: "Carbohydrate",
    calories: 112,
    protein: 2.6,
    carbs: 23,
    fat: 0.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 14,
    name: "Quinoa (Cooked)",
    category: "Carbohydrate",
    calories: 120,
    protein: 4.4,
    carbs: 22,
    fat: 1.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 15,
    name: "Sweet Potato (Baked)",
    category: "Carbohydrate",
    calories: 90,
    protein: 2,
    carbs: 20.7,
    fat: 0.1,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "cup"]
  },
  {
    id: 16,
    name: "Oatmeal",
    category: "Carbohydrate",
    calories: 6,
    protein: 0.26,
    carbs: 1.08,
    fat: 0.1,
    servingSize: 10,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 17,
    name: "White Rice (Cooked)",
    category: "Carbohydrate",
    calories: 130,
    protein: 2.7,
    carbs: 28,
    fat: 0.3,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 18,
    name: "Whole Wheat Pasta (Cooked)",
    category: "Carbohydrate",
    calories: 124,
    protein: 5.3,
    carbs: 25,
    fat: 1.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 19,
    name: "Banana",
    category: "Carbohydrate",
    calories: 89,
    protein: 1.1,
    carbs: 22.8,
    fat: 0.3,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "large", "small"]
  },
  {
    id: 20,
    name: "Boiled Potato",
    category: "Carbohydrate",
    calories: 104,
    protein: 1.81,
    carbs: 19.48,
    fat: 2.39,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "medium", "large", "small"]
  },
  {
    id: 21,
    name: "Apple",
    category: "Carbohydrate",
    calories: 52,
    protein: 0.3,
    carbs: 14,
    fat: 0.2,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "large", "small"]
  },
  {
    id: 22,
    name: "Blueberries",
    category: "Carbohydrate",
    calories: 57,
    protein: 0.7,
    carbs: 14.5,
    fat: 0.3,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 23,
    name: "Bread",
    category: "Carbohydrate",
    calories: 45,
    protein: 2.5,
    carbs: 9,
    fat: 0.5,
    servingSize: 1,
    servingUnit: "slice",
    servingOptions: ["slice", "g"]
  },
  {
    id: 24,
    name: "Jasmine Rice (Cooked)",
    category: "Carbohydrate",
    calories: 170,
    protein: 3.81,
    carbs: 32.14,
    fat: 2.5,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  // Fats
  {
    id: 25,
    name: "Avocado",
    category: "Fat",
    calories: 160,
    protein: 2,
    carbs: 8.5,
    fat: 14.7,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "half"]
  },
  {
    id: 26,
    name: "Almonds",
    category: "Fat",
    calories: 579,
    protein: 21.2,
    carbs: 21.6,
    fat: 49.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "handful"]
  },
  {
    id: 27,
    name: "Olive Oil",
    category: "Fat",
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    servingSize: 1,
    servingUnit: "tbsp",
    servingOptions: ["tbsp", "tsp", "ml"]
  },
  {
    id: 28,
    name: "Peanut Butter",
    category: "Fat",
    calories: 200,
    protein: 25,
    carbs: 15.5,
    fat: 6.5,
    servingSize: 50,
    servingUnit: "g",
    servingOptions: ["g", "tbsp", "tsp"]
  },
  {
    id: 29,
    name: "Walnuts",
    category: "Fat",
    calories: 654,
    protein: 15.2,
    carbs: 13.7,
    fat: 65.2,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "handful"]
  },
  {
    id: 30,
    name: "Coconut Oil",
    category: "Fat",
    calories: 862,
    protein: 0,
    carbs: 0,
    fat: 99.1,
    servingSize: 1,
    servingUnit: "tbsp",
    servingOptions: ["tbsp", "tsp", "g"]
  },
  {
    id: 31,
    name: "Cashews",
    category: "Fat",
    calories: 553,
    protein: 18.2,
    carbs: 30.2,
    fat: 43.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "handful"]
  },
  {
    id: 32,
    name: "Blue Cheese",
    category: "Fat",
    calories: 60,
    protein: 3.52,
    carbs: 1,
    fat: 4.52,
    servingSize: 1,
    servingUnit: "tbsp",
    servingOptions: ["tbsp", "g", "oz"]
  },
  // Vegetables
  {
    id: 33,
    name: "Broccoli",
    category: "Vegetable",
    calories: 34,
    protein: 2.8,
    carbs: 7,
    fat: 0.4,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "head"]
  },
  {
    id: 34,
    name: "Spinach",
    category: "Vegetable",
    calories: 8,
    protein: 1,
    carbs: 1.33,
    fat: 0,
    servingSize: 1,
    servingUnit: "oz",
    servingOptions: ["oz", "g", "cup", "handful"]
  },
  {
    id: 35,
    name: "Bell Peppers",
    category: "Vegetable",
    calories: 31,
    protein: 1,
    carbs: 7,
    fat: 0.3,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "cup"]
  },
  {
    id: 36,
    name: "Asparagus",
    category: "Vegetable",
    calories: 20,
    protein: 2.2,
    carbs: 3.9,
    fat: 0.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "spear", "cup"]
  },
  {
    id: 37,
    name: "Cauliflower",
    category: "Vegetable",
    calories: 25,
    protein: 1.9,
    carbs: 5,
    fat: 0.3,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "head"]
  },
  {
    id: 38,
    name: "Green Beans",
    category: "Vegetable",
    calories: 31,
    protein: 1.8,
    carbs: 7,
    fat: 0.2,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 39,
    name: "Carrots",
    category: "Vegetable",
    calories: 27,
    protein: 0.57,
    carbs: 5.84,
    fat: 0.15,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "cup"]
  },
  {
    id: 40,
    name: "Cucumber",
    category: "Vegetable",
    calories: 16,
    protein: 0.7,
    carbs: 4,
    fat: 0.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "medium"]
  },
  {
    id: 41,
    name: "Tomatoes",
    category: "Vegetable",
    calories: 18,
    protein: 0.9,
    carbs: 3.9,
    fat: 0.2,
    servingSize: 1,
    servingUnit: "medium",
    servingOptions: ["medium", "g", "cup"]
  },
  {
    id: 42,
    name: "Lettuce (Romaine)",
    category: "Vegetable",
    calories: 17,
    protein: 1.2,
    carbs: 3.3,
    fat: 0.3,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "head"]
  },
  // Dairy & Alternatives
  {
    id: 43,
    name: "Milk (2%)",
    category: "Protein",
    calories: 50,
    protein: 3.3,
    carbs: 4.8,
    fat: 2,
    servingSize: 1,
    servingUnit: "cup",
    servingOptions: ["cup", "ml", "glass"]
  },
  {
    id: 44,
    name: "Cheddar Cheese",
    category: "Fat",
    calories: 403,
    protein: 25,
    carbs: 1.3,
    fat: 33.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "slice"]
  },
  {
    id: 45,
    name: "Mozzarella Cheese",
    category: "Protein",
    calories: 280,
    protein: 28,
    carbs: 3.1,
    fat: 17,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "ball"]
  },
  {
    id: 46,
    name: "Almond Milk (Unsweetened)",
    category: "Fat",
    calories: 17,
    protein: 0.6,
    carbs: 1.5,
    fat: 1.2,
    servingSize: 1,
    servingUnit: "cup",
    servingOptions: ["cup", "ml"]
  },
  // Legumes & Beans
  {
    id: 47,
    name: "Black Beans (Cooked)",
    category: "Carbohydrate",
    calories: 115,
    protein: 7.26,
    carbs: 20.97,
    fat: 0.48,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 48,
    name: "Chickpeas (Cooked)",
    category: "Protein",
    calories: 164,
    protein: 8.9,
    carbs: 27.4,
    fat: 2.6,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 49,
    name: "Lentils (Cooked)",
    category: "Protein",
    calories: 116,
    protein: 9,
    carbs: 20,
    fat: 0.4,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 50,
    name: "Kidney Beans (Cooked)",
    category: "Protein",
    calories: 127,
    protein: 8.7,
    carbs: 22.8,
    fat: 0.5,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  // Additional foods
  {
    id: 51,
    name: "Pinto Beans (Cooked)",
    category: "Protein",
    calories: 143,
    protein: 9.0,
    carbs: 26.2,
    fat: 0.7,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 52,
    name: "Tilapia Fish (Cooked)",
    category: "Protein",
    calories: 128,
    protein: 26.15,
    carbs: 0,
    fat: 2.65,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "fillet"]
  },
  {
    id: 53,
    name: "Turkey Breast (Cooked)",
    category: "Protein",
    calories: 135,
    protein: 30.0,
    carbs: 0,
    fat: 1.0,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "slice"]
  },
  {
    id: 54,
    name: "Bacon",
    category: "Fat",
    calories: 417,
    protein: 37.0,
    carbs: 1.4,
    fat: 32.0,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "slice", "oz"]
  },
  {
    id: 55,
    name: "Kale",
    category: "Vegetable",
    calories: 49,
    protein: 4.3,
    carbs: 8.8,
    fat: 0.9,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup"]
  },
  {
    id: 56,
    name: "Strawberries",
    category: "Carbohydrate",
    calories: 32,
    protein: 0.7,
    carbs: 7.7,
    fat: 0.3,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "berry"]
  },
  {
    id: 57,
    name: "Bagel",
    category: "Carbohydrate",
    calories: 270,
    protein: 10.5,
    carbs: 53.0,
    fat: 1.7,
    servingSize: 1,
    servingUnit: "bagel",
    servingOptions: ["bagel", "half", "g"]
  },
  {
    id: 58,
    name: "Hummus",
    category: "Fat",
    calories: 166,
    protein: 7.9,
    carbs: 14.3,
    fat: 9.6,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "tbsp", "cup"]
  },
  {
    id: 59,
    name: "Chia Seeds",
    category: "Fat",
    calories: 486,
    protein: 16.5,
    carbs: 42.1,
    fat: 30.7,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "tbsp"]
  },
  {
    id: 60,
    name: "Tangerine",
    category: "Carbohydrate",
    calories: 52,
    protein: 0.9,
    carbs: 13.07,
    fat: 0.3,
    servingSize: 1,
    servingUnit: "large",
    servingOptions: ["large", "medium", "small", "g"]
  },
  {
    id: 61,
    name: "Dark Chocolate (70%)",
    category: "Fat",
    calories: 598,
    protein: 7.8,
    carbs: 45.9,
    fat: 42.6,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "square", "oz"]
  },
  {
    id: 62,
    name: "Honey",
    category: "Carbohydrate",
    calories: 304,
    protein: 0.3,
    carbs: 82.4,
    fat: 0,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "tbsp", "tsp"]
  },
  {
    id: 63,
    name: "Maple Syrup",
    category: "Carbohydrate",
    calories: 260,
    protein: 0,
    carbs: 67.0,
    fat: 0.1,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "tbsp", "tsp"]
  },
  {
    id: 64,
    name: "Ground Flaxseed",
    category: "Fat",
    calories: 534,
    protein: 18.3,
    carbs: 28.9,
    fat: 42.2,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "tbsp"]
  },
  {
    id: 65,
    name: "Protein Bar",
    category: "Protein",
    calories: 240,
    protein: 20,
    carbs: 20,
    fat: 9,
    servingSize: 1,
    servingUnit: "bar",
    servingOptions: ["bar", "g"]
  },
  // New food items
  {
    id: 66,
    name: "Alice Ice Cream",
    category: "Carbohydrate",
    calories: 200,
    protein: 3.51,
    carbs: 21.91,
    fat: 10.36,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "scoop"]
  },
  {
    id: 67,
    name: "Boom Chicka Popcorn",
    category: "Carbohydrate",
    calories: 140,
    protein: 2,
    carbs: 14,
    fat: 11,
    servingSize: 1,
    servingUnit: "serving",
    servingOptions: ["serving", "cup", "g"]
  },
  {
    id: 68,
    name: "Fried Pork Rinds",
    category: "Protein",
    calories: 80,
    protein: 9,
    carbs: 0,
    fat: 5,
    servingSize: 1,
    servingUnit: "serving",
    servingOptions: ["serving", "oz", "g"]
  },
  {
    id: 69,
    name: "Grapes",
    category: "Carbohydrate",
    calories: 69,
    protein: 0.72,
    carbs: 18.1,
    fat: 0.16,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "handful"]
  },
  {
    id: 70,
    name: "Ground Beef 88% Lean",
    category: "Protein",
    calories: 188,
    protein: 19.65,
    carbs: 0,
    fat: 11.61,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "oz", "patty"]
  },
  {
    id: 71,
    name: "Pirao",
    category: "Carbohydrate",
    calories: 67,
    protein: 3.33,
    carbs: 13.33,
    fat: 0,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "serving"]
  },
  {
    id: 72,
    name: "Watermelon",
    category: "Carbohydrate",
    calories: 30,
    protein: 0.61,
    carbs: 7.55,
    fat: 0.15,
    servingSize: 100,
    servingUnit: "g",
    servingOptions: ["g", "cup", "slice"]
  }
];

export const getFoodsByCategory = () => {
  const categories = {};
  foodDatabase.forEach(food => {
    if (!categories[food.category]) {
      categories[food.category] = [];
    }
    categories[food.category].push(food);
  });
  return categories;
};

export const getFoodById = (id) => {
  return foodDatabase.find(food => food.id === id);
};

// Conversion factors for different serving units
export const getConversionFactor = (food, targetUnit) => {
  const conversions = {
    // Weight conversions
    'g': {'oz': 0.035274, 'kg': 0.001},
    'oz': {'g': 28.3495, 'kg': 0.0283495},
    
    // Volume conversions
    'cup': {'ml': 240, 'tbsp': 16, 'tsp': 48},
    'tbsp': {'ml': 15, 'cup': 0.0625, 'tsp': 3},
    'tsp': {'ml': 5, 'cup': 0.0208, 'tbsp': 0.333},
    'ml': {'cup': 0.00417, 'tbsp': 0.0676, 'tsp': 0.2029},
    
    // Food-specific conversions (approximate)
    'egg': {'g': 50},
    'scoop': {'g': 30},
    'slice': {'g': 28},
    'medium': {'g': 150}, // Default for medium fruits/vegetables
    'large': {'g': 200},
    'small': {'g': 100},
    'piece': {'g': 30},
    'fillet': {'g': 150},
    'patty': {'g': 113},
    'container': {'g': 170},
    'block': {'g': 350},
    'steak': {'g': 225},
    'can': {'g': 165},
    'thigh': {'g': 135},
    'head': {'g': 500},
    'handful': {'g': 28},
    'half': {'g': 75},
    'spear': {'g': 15},
    'glass': {'ml': 240},
    'ball': {'g': 125},
    'bagel': {'g': 105},
    'berry': {'g': 12},
    'bar': {'g': 60},
    'square': {'g': 10},
    'serving': {'g': 30}
  };
  
  if (food.servingUnit === targetUnit) return 1;
  return conversions[food.servingUnit]?.[targetUnit] || 1;
};